export const subscriptionFragment = /* GraphQL */ `
  fragment subscriptionData on UserSubscription {
    id
    end
    start
    status
    stripeID
    type
    seatCount
    quotaCustom {
      products
      projects
      quoteSignatures
      subTeams
    }
    userSubscriptionsId
    organizationSubscriptionsId
    cancelAt
  }
`
